export default __webpack_public_path__ + "static/media/ladyinsweater.167ae528.svg";